/**
 * Contains all tip form page components.
 */

import domContentLoaded from 'utils/domContentLoaded';
import reactComponentManager from 'utils/reactComponentManager';
import TipForm from 'components/tipform';
import ComplaintForm from 'components/complaintform';

import './index.scss';

// import 'scss/videos/index.scss';

domContentLoaded(() => {
  reactComponentManager({
    TipForm,
    ComplaintForm,
  });
});

if (module.hot) {
  module.hot.accept();

  reactComponentManager({
    TipForm,
    ComplaintForm,
  });
}
